module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('list', {
    ref: "list",
    staticClass: "albums",
    attrs: {
      "scroll": true,
      "items": _vm.albums,
      "link": "album",
      "fields": ['name', 'band', 'date'],
      "type": "img"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f3664d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/AlbumsByStyle.vue
// module id = 273
// module chunks = 0